/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-console */
/* eslint-disable import/no-named-as-default */
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/solid";
import { format } from "date-fns";
import { Field, Form, Formik } from "formik";
import Cookies from "js-cookie";
import _, { forEach } from "lodash";
import { use, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import CommentsList from "components/lib/Global/CommentsList";
import Button from "components/lib/Shared/Button";
import DatePickerField from "components/lib/Shared/DatePickerField";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "components/lib/Shared/Icons/sflIcons";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import ModalWrapper from "components/lib/Shared/ModalWrapper";
import OnlyOfficeDocumentEditor from "components/lib/Shared/OnlyOfficeDocumentEditor";
import Overlay from "components/lib/Shared/Overlay";
import SectionDescription from "components/lib/Shared/SectionDescription";
import ValidationError from "components/lib/Shared/ValidationError";
import TemplateSummary from "components/OrgAndSuperAdminDashboard/TemplatesSettings/Templates/SummaryForm";
import ArticlesOfAssociation from "components/PLCTABS/CompanyFormationTab/CompanyFormationComponents/ArticlesOfAssociation";
import FileUploadForm from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm";
import { Constants } from "config/constants";
import ManualTransactionEditContext from "context/ManualTransactionEditContext";
import UpdateHistoryContext from "context/UpdateHistoryContext";
import { useToast } from "hooks/useToast";
import { closeModal, openModal } from "state/slices/modals";
import {
  addTemplateAsync,
  deleteDraftTemplateAsync,
  getTemplateForApplicantAsync,
  updateTemplateState,
} from "state/slices/template";
import {
  addTemplateVersionAsync,
  deleteDraftTemplateVersionAsync,
  editTemplateVersionAsync,
} from "state/slices/templateVersion";
import { getFullName } from "utils";
import { copyFile, deleteFile, handleFilesUpload } from "utils/filesUtils";
import { handleCompanyMaintenanceFormData } from "utils/transactionRequestHandler";
import validation from "./goverance/validation";
import { Roles_Permissions_Constants } from "config/roles-permissions";

const MODAL_NAME = "template_override_confirmation_modal";

const Governance = ({
  handleSummaryNavigation,
  goToPreviousStep,
  goToNextStep,
}) => {
  const role = Cookies.get("role");

  const dispatch = useDispatch();
  const { toast, clearAllToasts } = useToast();
  const summaryFormRef = useRef(null);

  const { companyFormation, company } = useSelector(
    (state) => state.companySlice
  );

  const { dashboardRoles, dashboardPermissions } = useSelector(
    (state) => state.companyDashboardSlice
  );

  const {
    isInUpdateHistoryContext,
    addUniqueTransactionId,
    transactionExists,
    fileNameToDelete,
    setFileNameToDelete,
    setRefechTransactionsOnUpdate,
    selectionsMade,
    dateFrom,
    dateTo,
    transactions,
  } = useContext(UpdateHistoryContext);

  const { transactionToEdit, isInManualTransactionEditContext } = useContext(
    ManualTransactionEditContext
  );

  const {
    isUpdateHistory,
    dateTo: To,
    dateFrom: From,
    historyTransactions,
    period,
  } = useSelector((state) => state.transferYourBusinessSlice);

  const existingTransaction = transactionExists(
    Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_ARTICLES
  );

  const { companyId } = useParams();

  const closeArticlesAccordionRef = useRef(null);
  const closeSummaryAccordionRef = useRef(null);
  const closeFilePreviewRef = useRef(null);

  const { step2 } = companyFormation;

  const { transformedComments } = useSelector((state) => state.commentsSlice);

  const { batchNo } = useSelector((state) => state.batchNumberSlice);

  const {
    selectedTemplate,
    selectedVersion,
    getTemplateForApplicant,
    showOverlay,
  } = useSelector((state) => state.templateSlice);
  const { modalRow } = useSelector((state) => state.modalsSlice);
  const currentUser = useSelector((state) => state.userSlice);

  const conversionTransactionExists = transactionExists(
    Constants.TRANSACTION_CHANGE_TYPES.CONVERSION
  );

  const isConversionTransaction =
    selectionsMade?.summary?.companyChanges?.some((change) =>
      ["conversionPLCtoPVT", "conversionPVTtoPLC"].includes(change)
    ) && conversionTransactionExists?._id;

  const companyConversionType =
    conversionTransactionExists?.companyChangedFields?.type;

  const { schemaInitialValues, schema } = validation(isConversionTransaction);

  // Function to get initial values from transaction or schema
  const getInitialValuesFromTransaction = () => {
    // Check if there's an existing transaction for CHANGE_OF_ARTICLES
    if (existingTransaction && existingTransaction._id) {
      const changedFields = existingTransaction.companyChangedFields || {};
      const initialValues = _.merge({}, schemaInitialValues, step2);

      // Apply transaction fields
      if (changedFields.dateOfChange) {
        initialValues.dateOfChange = changedFields.dateOfChange;
      }
      if (changedFields.articlesOfAssociationToUse) {
        initialValues.articlesOfAssociationToUse =
          changedFields.articlesOfAssociationToUse;
      }
      if (changedFields.associationChoice) {
        initialValues.associationChoice = changedFields.associationChoice;
      }
      if (changedFields.articlesOfAssociation) {
        initialValues.articlesOfAssociation = {
          ...initialValues.articlesOfAssociation,
          ...changedFields.articlesOfAssociation,
        };
      }
      if (changedFields.fileUploads?.template) {
        initialValues.fileUploads = {
          template: changedFields.fileUploads.template,
        };
      }
      if (changedFields.summary) {
        initialValues.summary = changedFields.summary;
        summaryFormRef?.current?.setValues(changedFields.summary);
      } else {
        initialValues.summary = changedFields.alternativeSummary;
        summaryFormRef?.current?.setValues(changedFields.alternativeSummary);
      }

      if (changedFields.templateVersionId) {
        initialValues.templateVersionId = changedFields.templateVersionId;
      }

      return initialValues;
    }

    // Fallback to transactionToEdit if in edit mode
    if (
      isInManualTransactionEditContext &&
      transactionToEdit?._id &&
      !isConversionTransaction
    ) {
      const changedFields = transactionToEdit.companyChangedFields || {};
      const initialValues = _.merge({}, schemaInitialValues, step2);

      if (changedFields.dateOfChange) {
        initialValues.dateOfChange = changedFields.dateOfChange;
      }
      if (changedFields.articlesOfAssociationToUse) {
        initialValues.articlesOfAssociationToUse =
          changedFields.articlesOfAssociationToUse;
      }
      if (changedFields.associationChoice) {
        initialValues.associationChoice = changedFields.associationChoice;
      }
      if (changedFields.articlesOfAssociation) {
        initialValues.articlesOfAssociation = {
          ...initialValues.articlesOfAssociation,
          ...changedFields.articlesOfAssociation,
        };
      }
      if (changedFields.fileUploads?.template) {
        initialValues.fileUploads = {
          template: changedFields.fileUploads.template,
        };
      }

      if (changedFields.summary) {
        initialValues.summary = changedFields.summary;
        summaryFormRef?.current?.setValues(changedFields.summary);
      } else {
        initialValues.summary = changedFields.alternativeSummary;
        summaryFormRef?.current?.setValues(changedFields.alternativeSummary);
      }

      if (changedFields.templateVersionId) {
        initialValues.templateVersionId = changedFields.templateVersionId;
      }

      return initialValues;
    }

    if (
      isConversionTransaction &&
      conversionTransactionExists?.companyChangedFields?.conversionTemplate
    ) {
      const changedFields =
        conversionTransactionExists.companyChangedFields?.conversionTemplate;

      const initialValues = _.merge({}, schemaInitialValues, step2);

      if (changedFields.articlesOfAssociationToUse) {
        initialValues.articlesOfAssociationToUse =
          changedFields.articlesOfAssociationToUse;
      }
      if (changedFields.associationChoice) {
        initialValues.associationChoice = changedFields.associationChoice;
      }
      if (changedFields.articlesOfAssociation) {
        initialValues.articlesOfAssociation = {
          ...initialValues.articlesOfAssociation,
          ...changedFields.articlesOfAssociation,
        };
      }
      if (changedFields.fileUploads?.template) {
        initialValues.fileUploads = {
          template: changedFields.fileUploads.template,
        };
      }

      if (changedFields.summary) {
        initialValues.summary = changedFields.summary;
        summaryFormRef?.current?.setValues(changedFields.summary);
      }

      if (changedFields.templateVersionId) {
        initialValues.templateVersionId = changedFields.templateVersionId;
      }

      return initialValues;
    }

    // Default to schema initial values merged with step2
    return _.merge({}, schemaInitialValues, step2);
  };

  const initialValues = getInitialValuesFromTransaction();

  const articlesOfAssociationToUseComments =
    transformedComments?.["articlesOfAssociation"]
      ?.articlesOfAssociationToUse ?? [];

  // Helper function to determine template type
  const getTemplateType = (articleType) => {
    switch (articleType) {
      case "ModifiedArticlesOfAssociation":
        return "Short";
      case "ModelArticlesOfAssociation":
        return "Model";
      case "OwnArticlesOfAssociation":
        return "Long";
      default:
        return "Long"; // Fallback for unexpected values
    }
  };

  function getChangedFields(values, originalValues) {
    const changedFields = {};

    // Compare top-level fields
    const topLevelFields = [
      "dateOfChange",
      "associationChoice",
      "articlesOfAssociationToUse",
    ];
    for (const field of topLevelFields) {
      if (!_.isEqual(values[field], originalValues[field])) {
        changedFields[field] = values[field];
      }
    }

    // Compare articlesOfAssociation fields, excluding template
    const articlesFields = [
      "articlesType",
      "nameOfRegulator",
      "natureOfBusiness",
      "regulatorInstitute",
    ];
    for (const field of articlesFields) {
      if (
        !_.isEqual(
          values.articlesOfAssociation?.[field],
          originalValues.articlesOfAssociation?.[field]
        )
      ) {
        if (!changedFields.articlesOfAssociation) {
          changedFields.articlesOfAssociation = {};
        }
        changedFields.articlesOfAssociation[field] =
          values.articlesOfAssociation[field];
      }
    }

    // Compare fileUploads.template
    if (
      !_.isEqual(
        values.fileUploads?.template,
        originalValues.fileUploads?.template
      )
    ) {
      changedFields.fileUploads = { template: values.fileUploads.template };
    }

    // Compare summary object fields
    const summaryKeys = Object.keys(values.summary || {});
    for (const key of summaryKeys) {
      if (!_.isEqual(values.summary[key], originalValues.summary?.[key])) {
        if (!changedFields.summary) {
          changedFields.summary = {};
        }
        changedFields.summary[key] = values.summary[key];
      }
    }

    return changedFields;
  }

  const isUploader = dashboardPermissions.some(
    (permission) =>
      permission.name ===
      Roles_Permissions_Constants.DASHBOARD_PERMISSIONS.EDIT_OTHER_DATA
  );

  useEffect(() => {
    if (
      isConversionTransaction &&
      conversionTransactionExists?.companyChangedFields?.conversionTemplate
    ) {
      dispatch(
        updateTemplateState({
          selectedTemplate: {},
        })
      );
    }
  }, [
    isConversionTransaction,
    conversionTransactionExists?.companyChangedFields?.conversionTemplate,
  ]);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...initialValues,
        resolvedFields: [],
        summary: initialValues.summary || {},
        fileUploads: initialValues.fileUploads || {},
        dateOfChange: initialValues.dateOfChange || "",
      }}
      validationSchema={schema}
      onSubmit={async (values) => {
        clearAllToasts();

        if (_.isEmpty(values?.fileUploads?.template)) {
          toast(
            "error",
            "Articles of Association and its Summary are required."
          );
          return;
        }

        // validate summary form
        const summaryFormErrors = await summaryFormRef.current?.validateForm();
        if (!_.isEmpty(summaryFormErrors)) {
          summaryFormRef.current.submitForm();
          return;
        }

        const templateVersions =
          company?.articlesOfAssociation?.template?.versions || [];

        // Filter out draft versions and sort by versionNumber in descending order
        const nonDraftVersions = fiteredVersions(templateVersions);

        const latestTemplate = nonDraftVersions[0] || {};

        const { fileUploads, summary } = latestTemplate;

        const originalValues = {
          associationChoice: company?.associationChoice ?? "",
          articlesOfAssociationToUse: company?.articlesOfAssociationToUse ?? [],
          articlesOfAssociation: company?.articlesOfAssociation ?? {},
          summary: summary ?? {},
          fileUploads: fileUploads ?? {},
          dateOfChange: "",
        };

        // Merge values with summary form values when uploading your own articles of association
        let mergedValues = {
          ...values,
        };

        if (summaryFormRef.current?.values) {
          mergedValues = {
            ...mergedValues,
            summary: summaryFormRef.current?.values,
          };
        }

        let changedFields = getChangedFields(mergedValues, originalValues);

        closeArticlesAccordionRef.current?.click();
        closeSummaryAccordionRef.current?.click();

        try {
          const { template } = changedFields.fileUploads;
          if (typeof template !== "string" || !template) {
            toast(
              "error",
              "No template uploaded, please click upload button to upload one."
            );
            return;
          }

          const { articlesOfAssociationToUse, associationChoice } = values;
          const {
            articlesOfAssociationToUse: companyArticlesToUse,
            associationChoice: companyAssociationChoice,
            articlesOfAssociation,
          } = company || {};

          const articlesOfAssociationToUseEditing =
            existingTransaction?.companyChangedFields
              ?.articlesOfAssociationToUse ??
            transactionToEdit?.companyChangedFields
              ?.articlesOfAssociationToUse ??
            false;

          const associationChoiceEditing =
            existingTransaction?.companyChangedFields?.associationChoice ??
            transactionToEdit?.companyChangedFields?.associationChoice ??
            false;

          const hasArticlesChanged = articlesOfAssociationToUseEditing
            ? articlesOfAssociationToUseEditing !==
                articlesOfAssociationToUse &&
              articlesOfAssociationToUse !== companyArticlesToUse
            : articlesOfAssociationToUse !== companyArticlesToUse;

          const hasAssociationChanged = associationChoiceEditing
            ? associationChoiceEditing !== associationChoice &&
              associationChoice !== companyAssociationChoice
            : associationChoice !== companyAssociationChoice;

          const isEditMode =
            existingTransaction?._id ||
            (isInManualTransactionEditContext && transactionToEdit?._id);

          // Create new daft template version
          let versionNumber;
          let templateData = {};
          let versionData = {};
          let transactionPayload = {};

          if (
            !latestTemplate?.versionNumber &&
            !company?.articlesOfAssociation?.template
          ) {
            versionNumber = 0.1; // Starting version
            //TODO: Create new template for the company
            toast("error", "Please create a template for the company first");

            templateData = {
              category: selectedTemplate?.category,
              name: selectedTemplate?.name ?? "Articles of Association",
              entityType: selectedTemplate?.entityType ?? company.type,
              templateType:
                selectedTemplate?.templateType ??
                getTemplateType(values.articlesOfAssociationToUse),
              templateVersionStatus: "Draft",
              templateToUse: values?.articlesOfAssociationToUse,
              company: company._id,
              fileUploads: values?.fileUploads,
              summary: mergedValues?.summary,
              versionNumber,
            };

            const result = await dispatch(
              addTemplateAsync({ data: templateData })
            );
          } else {
            if (
              latestTemplate.versionNumber >= 0.1 &&
              latestTemplate.versionNumber <= 0.9
            ) {
              versionNumber = 1.1;
            } else if (Number.isInteger(latestTemplate.versionNumber)) {
              versionNumber = latestTemplate.versionNumber + 0.1;
            } else {
              versionNumber = latestTemplate.versionNumber + 0.1;
            }
            // Format to one decimal place to ensure clean output
            versionNumber = parseFloat(versionNumber.toFixed(1));

            let templateVersionId;
            let templateId;

            if (isConversionTransaction) {
              let conversionTemplate = {};
              const conversionArticlesOfAssociationToUse =
                conversionTransactionExists?.companyChangedFields
                  ?.conversionTemplate?.articlesOfAssociationToUse;
              const conversionAssociationChoice =
                conversionTransactionExists?.companyChangedFields
                  ?.conversionTemplate?.associationChoice;

              if (
                conversionArticlesOfAssociationToUse &&
                conversionAssociationChoice
              ) {
                if (
                  conversionArticlesOfAssociationToUse !==
                    articlesOfAssociationToUse ||
                  conversionAssociationChoice !== associationChoice
                ) {
                  //Create new template
                  templateData = {
                    category: selectedTemplate?.category,
                    name: selectedTemplate?.name ?? "Articles of Association",
                    entityType: companyConversionType,
                    templateType: getTemplateType(
                      values.articlesOfAssociationToUse
                    ),
                    templateVersionStatus: "Draft",
                    templateToUse: values?.articlesOfAssociationToUse,
                    company: company._id,
                    fileUploads: values?.fileUploads,
                    summary: mergedValues?.summary,
                    versionNumber,
                    versionStatus: "Draft",
                    status: "Draft",
                    effectiveFrom: values?.dateOfChange || new Date(),
                  };
                  const result = await dispatch(
                    addTemplateAsync({ data: templateData })
                  );

                  if (result.error) {
                    toast(
                      "error",
                      result.payload?.messageText ??
                        "Something went wrong please try again"
                    );
                  }
                  {
                    templateVersionId =
                      result?.payload?.template?.versions?.[0]?._id;
                    templateId = result?.payload?.template?._id;
                  }
                } else {
                  //update existing template
                  const editCoversionTemplateVersionId =
                    conversionTransactionExists?.companyChangedFields
                      ?.conversionTemplate?.templateVersionId;
                  const editConversionTemplateId =
                    conversionTransactionExists?.companyChangedFields
                      ?.conversionTemplate?.templateId;

                  //Update existing version
                  versionData = {
                    summary: mergedValues?.summary,
                    fileUploads: values?.fileUploads,
                    effectiveFrom: values?.dateOfChange || new Date(),
                  };

                  const result = await dispatch(
                    editTemplateVersionAsync({
                      templateVersionId: editCoversionTemplateVersionId,
                      data: versionData,
                    })
                  );

                  if (result.error) {
                    toast("error", "Something went wrong please try again");
                    return;
                  }
                  templateVersionId = result?.payload?._id;
                  templateId = editConversionTemplateId;
                }
              } else {
                //Create new template

                templateData = {
                  category: selectedTemplate?.category,
                  name: selectedTemplate?.name ?? "Articles of Association",
                  entityType: companyConversionType,
                  templateType: getTemplateType(
                    values.articlesOfAssociationToUse
                  ),
                  templateVersionStatus: "Draft",
                  templateToUse: values?.articlesOfAssociationToUse,
                  company: company._id,
                  fileUploads: values?.fileUploads,
                  summary: mergedValues?.summary,
                  versionNumber,
                  versionStatus: "Draft",
                  status: "Draft",
                  effectiveFrom: values?.dateOfChange || new Date(),
                };
                const result = await dispatch(
                  addTemplateAsync({ data: templateData })
                );

                if (result.error) {
                  toast(
                    "error",
                    result.payload?.messageText ??
                      "Something went wrong please try again"
                  );
                }
                {
                  templateVersionId =
                    result?.payload?.template?.versions?.[0]?._id;
                  templateId = result?.payload?.template?._id;
                }
              }
              conversionTemplate = {
                templateVersionId,
                templateId,
                articlesOfAssociation: values?.articlesOfAssociation,
                associationChoice: values?.associationChoice,
                articlesOfAssociationToUse: values?.articlesOfAssociationToUse,
                fileUploads: values?.fileUploads,
                summary: mergedValues?.summary,
                dateOfChange: values?.dateOfChange,
              };

              transactionPayload = {
                companyChangedFields: {
                  ...conversionTransactionExists?.companyChangedFields,
                  conversionTemplate,
                },
                articlesTemplate: conversionTemplate?.templateId,
                companyId,
                batchNo,
                documentId: conversionTransactionExists?._id,
                period,
              };
              const result = await handleCompanyMaintenanceFormData(
                "existing-request",
                transactionPayload
              );

              if (result?.error) {
                toast(
                  "error",
                  "There was an error updating the transaction. Please try again."
                );
                return;
              }

              if (result?.payload?.status === true) {
                toast("success", "Transaction has been updated successfully");
                setRefechTransactionsOnUpdate(true);
              }
            } else {
              if (isEditMode) {
                if (hasArticlesChanged || hasAssociationChanged) {
                  //Create new template
                  templateData = {
                    category: selectedTemplate?.category,
                    name: selectedTemplate?.name ?? "Articles of Association",
                    entityType: selectedTemplate?.entityType ?? company.type,
                    templateType: getTemplateType(
                      values.articlesOfAssociationToUse
                    ),
                    templateVersionStatus: "Draft",
                    templateToUse: values?.articlesOfAssociationToUse,
                    company: company._id,
                    fileUploads: values?.fileUploads,
                    summary: mergedValues?.summary,
                    versionNumber,
                    versionStatus: "Draft",
                    status: "Draft",
                    effectiveFrom: values?.dateOfChange,
                  };

                  const result = await dispatch(
                    addTemplateAsync({ data: templateData })
                  );

                  if (result.error) {
                    toast(
                      "error",
                      result.payload?.messageText ??
                        "Something went wrong please try again"
                    );
                  }
                  {
                    templateVersionId =
                      result?.payload?.template?.versions?.[0]?._id;
                    templateId = result?.payload?.template?._id;
                  }
                } else {
                  const editTemplateVersionId =
                    existingTransaction?.companyChangedFields
                      ?.templateVersionId ||
                    transactionToEdit?.companyChangedFields?.templateVersionId;
                  const editTemplateId =
                    existingTransaction?.companyChangedFields?.templateId ||
                    transactionToEdit?.companyChangedFields?.templateId;

                  //Update existing version
                  versionData = {
                    summary: mergedValues?.summary,
                    fileUploads: values?.fileUploads,
                    effectiveFrom: values?.dateOfChange,
                  };

                  const result = await dispatch(
                    editTemplateVersionAsync({
                      templateVersionId: editTemplateVersionId,
                      data: versionData,
                    })
                  );

                  if (result.error) {
                    toast("error", "Something went wrong please try again");
                    return;
                  }
                  templateVersionId = result?.payload?._id;
                  templateId = editTemplateId;
                }
              } else {
                //Create new version which is a draft for the existing template and update the template
                if (
                  companyArticlesToUse === articlesOfAssociationToUse &&
                  companyAssociationChoice === associationChoice
                ) {
                  versionData = {
                    versionNumber,
                    summary: {
                      ...latestTemplate?.summary,
                      ...changedFields.summary,
                    },
                    status: "Draft",
                    templateId: company?.articlesOfAssociation?.template?._id,
                    fileUploads: values?.fileUploads,
                    effectiveFrom: values?.dateOfChange,
                  };

                  const result = await dispatch(
                    addTemplateVersionAsync({
                      data: versionData,
                    })
                  );

                  if (result.error) {
                    toast("error", "Something went wrong please try again");
                    return;
                  }

                  templateVersionId = result?.payload?.templateVersion?._id;
                  templateId = company?.articlesOfAssociation?.template?._id;
                } else {
                  //Create new template
                  templateData = {
                    category: selectedTemplate?.category,
                    name: selectedTemplate?.name ?? "Articles of Association",
                    entityType: selectedTemplate?.entityType ?? company.type,
                    templateType: getTemplateType(
                      values.articlesOfAssociationToUse
                    ),
                    templateVersionStatus: "Draft",
                    templateToUse: values?.articlesOfAssociationToUse,
                    company: company._id,
                    fileUploads: values?.fileUploads,
                    summary: mergedValues?.summary,
                    versionNumber,
                    versionStatus: "Draft",
                    status: "Draft",
                    effectiveFrom: values?.dateOfChange,
                  };

                  const result = await dispatch(
                    addTemplateAsync({ data: templateData })
                  );

                  if (result.error) {
                    toast(
                      "error",
                      result.payload?.messageText ??
                        "Something went wrong please try again"
                    );
                  }
                  {
                    templateVersionId =
                      result?.payload?.template?.versions?.[0]?._id;
                    templateId = result?.payload?.template?._id;
                  }
                }
              }
            }

            if (!isConversionTransaction) {
              if (isEditMode) {
                transactionPayload = {
                  companyId,
                  companyChangedFields: {
                    ...changedFields,
                    templateVersionId,
                    templateId,
                    alternativeSummary: mergedValues?.summary,
                    effectiveFromDate: changedFields?.dateOfChange,
                  },
                  articlesTemplate: templateId,
                  batchNo,
                  documentId:
                    existingTransaction?._id || transactionToEdit?._id,
                  period,
                };

                const result = await handleCompanyMaintenanceFormData(
                  "existing-request",
                  transactionPayload
                );
                if (result?.error) {
                  toast(
                    "error",
                    "There was an error updating the transaction. Please try again."
                  );
                  return;
                }

                if (result?.payload?.status === true) {
                  toast("success", "Transaction has been updated successfully");
                  setRefechTransactionsOnUpdate(true);
                }
              } else {
                transactionPayload = {
                  changeType:
                    Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_ARTICLES,
                  applicationType:
                    Constants.TRANSACTION_APPLICATION_TYPES.CHANGE_REGISTRATION,
                  transactionType: Constants.TRANSACTION_TYPES.MANUAL,
                  companyId,
                  companyChangedFields: {
                    ...changedFields,
                    templateVersionId,
                    templateId,
                    alternativeSummary: mergedValues?.summary,
                    effectiveFromDate: changedFields?.dateOfChange,
                  },
                  articlesTemplate: templateId,
                  approvalType:
                    Constants.TRANSACTION_APPROVAL_TYPES
                      .BOARD_SHAREHOLDER_APPROVAL,
                  batchNo,
                  isForHistory: true,
                  period,
                };

                const result = await handleCompanyMaintenanceFormData(
                  "new-request",
                  transactionPayload,
                  companyId
                );

                if (result?.payload?.errors) {
                  toast(
                    "error",
                    "There was an error creating the transaction. Please try again."
                  );
                  return;
                }

                if (result?.payload?.status === true) {
                  toast("success", "Transaction has been created successfully");
                  setRefechTransactionsOnUpdate(true);
                }

                addUniqueTransactionId(result?.payload?.savedTransaction?._id);
              }
            }

            handleSummaryNavigation("next");
          }
        } catch (error) {
          toast("error", error.message);
          return;
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        handleSubmit,
        setFieldValue,
      }) => {
        const [uploadingTemplate, setUploadingTemplate] = useState(false);
        const [deletingPreviousTemplate, setDeletingPreviousTemplate] =
          useState(false);

        const { articlesOfAssociationToUse, associationChoice } = values;
        const {
          articlesOfAssociationToUse: companyArticlesToUse,
          associationChoice: companyAssociationChoice,
          articlesOfAssociation: { template } = {},
        } = company || {};

        const isEditMode =
          (isInManualTransactionEditContext && transactionToEdit?._id) ||
          existingTransaction?._id;

        const showDeleteModal = useMemo(() => {
          return (
            values?.fileUploads?.template &&
            typeof values?.fileUploads?.template === "string"
          );
        }, [values?.fileUploads?.template]);

        const shouldUseExistingTemplate =
          articlesOfAssociationToUse &&
          associationChoice &&
          articlesOfAssociationToUse === companyArticlesToUse &&
          associationChoice === companyAssociationChoice &&
          template &&
          ["adopt", "uploadYourOwn"].includes(associationChoice);

        const handleChangeArticlesOfAssociationToUse = (e) => {
          const { name, value } = e.target;

          if (showDeleteModal) {
            dispatch(
              openModal({ modalName: MODAL_NAME, modalRow: { name, value } })
            );
          } else {
            setFieldValue(e.target.name, value);
          }
        };

        const handleChangeAssociationChoice = (e) => {
          const { name, value } = e.target;

          if (showDeleteModal) {
            dispatch(
              openModal({ modalName: MODAL_NAME, modalRow: { name, value } })
            );
          } else {
            setFieldValue(e.target.name, value);
          }
        };

        // Effect 1: Handle template selection and dispatch logic
        useEffect(() => {
          if (!articlesOfAssociationToUse || !associationChoice) return;

          if (isEditMode && values?.fileUploads?.template) return; // Skip template logic in edit mode when the file is already uploaded and not deleted

          setFieldValue("summary", {});
          setFieldValue("fileUploads", {});

          if (isConversionTransaction) {
            setFieldValue("summary", {});
            setFieldValue("fileUploads", {});
            dispatch(
              updateTemplateState({
                selectedTemplate: {},
              })
            );

            if (articlesOfAssociationToUse && associationChoice === "adopt") {
              dispatch(
                getTemplateForApplicantAsync({
                  name: "Articles of Association",
                  entityType: companyConversionType,
                  templateType: getTemplateType(articlesOfAssociationToUse),
                })
              );
            }
          } else {
            if (
              articlesOfAssociationToUse &&
              associationChoice === "adopt" &&
              !template
            ) {
              dispatch(
                getTemplateForApplicantAsync({
                  name: "Articles of Association",
                  entityType: company.type,
                  templateType: getTemplateType(articlesOfAssociationToUse),
                })
              );
            } else if (shouldUseExistingTemplate) {
              if (_.isEmpty(selectedTemplate)) {
                dispatch(updateTemplateState({ selectedTemplate: template }));
              }
            } else if (associationChoice === "adopt") {
              dispatch(
                getTemplateForApplicantAsync({
                  name: "Articles of Association",
                  entityType: company.type,
                  templateType: getTemplateType(articlesOfAssociationToUse),
                })
              );
            } else if (associationChoice === "uploadYourOwn") {
              //Upload your own

              if (!_.isEmpty(selectedTemplate)) {
                dispatch(updateTemplateState({ selectedTemplate: {} }));
              }
            }
          }
        }, [
          values.articlesOfAssociationToUse,
          values.associationChoice,
          company?.articlesOfAssociation,
          company?.articlesOfAssociationToUse,
          company?.associationChoice,
          company?.type,
          existingTransaction?._id,
          transactionToEdit?.id,
          isConversionTransaction,
        ]);
        const templateVersions = selectedTemplate?.versions || [];
        const nonDraftVersions = fiteredVersions(templateVersions);
        const latestTemplate = nonDraftVersions[0] || {};
        // Effect 2: Handle value setting and UI reset
        useEffect(() => {
          const handleEffect = async () => {
            if (isEditMode && values?.fileUploads?.template) {
              // Use existing values from the transaction
              setFieldValue("summary", values.summary || {});
              setFieldValue("fileUploads", values.fileUploads || {});
            } else {
              if (!_.isEmpty(selectedTemplate)) {
                // Use values from the latest template
                if (values.associationChoice === "uploadYourOwn") {
                  // Only dispatch if selectedTemplate is not already empty to avoid infinite loop
                  if (!_.isEmpty(selectedTemplate)) {
                    dispatch(updateTemplateState({ selectedTemplate: {} }));
                  }
                } else {
                  setFieldValue("summary", latestTemplate?.summary || {});
                  if (
                    articlesOfAssociationToUse !==
                      "ModelArticlesOfAssociation" &&
                    associationChoice === "adopt"
                  ) {
                    //Make a copy of the selected template. And not model articles of association
                    const templateToCopy =
                      latestTemplate?.fileUploads?.template;

                    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}/templates/${templateToCopy}`;

                    try {
                      //Copy template file from existing template to use in new template adoption
                      const response = await copyFile(fileUrl, "templates");

                      if (response.status === 200) {
                        //Delete existing copied template
                        if (fileNameToDelete) {
                          const response = await deleteFile({
                            fileName: fileNameToDelete,
                            folder: "templates",
                          });
                        }

                        const templateCopy = response.data;

                        setFieldValue("fileUploads", {
                          template: templateCopy,
                        });

                        setFileNameToDelete(templateCopy);
                      } else {
                        toast("error", "Something went wrong please try again");
                        return;
                      }
                    } catch (error) {
                      console.error("Error copying file:", error);
                      toast("error", "Failed to copy template file");
                    }
                  } else {
                    setFieldValue(
                      "fileUploads",
                      {
                        template: latestTemplate?.fileUploads?.template,
                      } ?? {}
                    );
                  }
                }
              }
            }
          };

          handleEffect();
        }, [selectedTemplate]);

        const handleUploadTemplate = async () => {
          try {
            if (!values.fileUploads?.template) return;
            setUploadingTemplate(true);
            setFieldValue("fileUploads", {});

            // remove previous uploaded template
            if (isConversionTransaction) {
              if (
                conversionTransactionExists?.companyChangedFields
                  ?.conversionTemplate
              ) {
                await dispatch(
                  deleteDraftTemplateAsync({
                    templateId:
                      conversionTransactionExists?.companyChangedFields
                        ?.conversionTemplate?.templateId,
                  })
                );
              } else {
                if (fileNameToDelete) {
                  const response = await deleteFile({
                    fileName: fileNameToDelete,
                    folder: "templates",
                  });
                }
              }
            } else {
              if (isEditMode) {
                const fileName =
                  existingTransaction?.companyChangedFields?.fileUploads
                    ?.template ||
                  transactionToEdit?.companyChangedFields?.fileUploads
                    ?.template;

                const response = await deleteFile({
                  fileName,
                  folder: "templates",
                });
              } else {
                if (fileNameToDelete) {
                  const response = await deleteFile({
                    fileName: fileNameToDelete,
                    folder: "templates",
                  });
                }
              }
            }
            const uploadedFiles = await handleFilesUpload(
              _.pick(values.fileUploads, ["template"]),
              null,
              false,
              "templates"
            );
            setFieldValue("fileUploads", uploadedFiles);
            setFileNameToDelete(uploadedFiles?.template);
          } catch (error) {
            toast("error", "Something went wrong please try again");
          } finally {
            setUploadingTemplate(false);
          }
        };

        const handleRemovePreviousTemplateVersion = async () => {
          try {
            setDeletingPreviousTemplate(true);
            if (isConversionTransaction) {
              if (
                conversionTransactionExists?.companyChangedFields
                  ?.conversionTemplate &&
                articlesOfAssociationToUse !== "ModelArticlesOfAssociation"
              ) {
                await dispatch(
                  deleteDraftTemplateAsync({
                    templateId:
                      conversionTransactionExists?.companyChangedFields
                        ?.conversionTemplate?.templateId,
                  })
                );

                dispatch(updateTemplateState({ selectedTemplate: {} }));
                setFieldValue("summary", {});
                setFieldValue("fileUploads", {});
              } else if (
                articlesOfAssociationToUse !== "ModelArticlesOfAssociation"
              ) {
                if (fileNameToDelete) {
                  const response = await deleteFile({
                    fileName: fileNameToDelete,
                    folder: "templates",
                  });
                }
                setFileNameToDelete("");
                if (!_.isEmpty(selectedTemplate)) {
                  dispatch(updateTemplateState({ selectedTemplate: {} }));
                }
                setFieldValue("summary", {});
                setFieldValue("fileUploads", {});
              }
            } else {
              if (isEditMode) {
                const templateIdToDelete =
                  transactionToEdit?.companyChangedFields?.templateId ||
                  existingTransaction?.companyChangedFields?.templateId;

                const templateVersionIdToDelete =
                  transactionToEdit?.companyChangedFields?.templateVersionId ||
                  existingTransaction?.companyChangedFields?.templateVersionId;

                const shouldDeleteTemplate =
                  articlesOfAssociationToUse !== companyArticlesToUse ||
                  associationChoice !== companyAssociationChoice;

                const shouldDeleteTepmlateVersion =
                  articlesOfAssociationToUse === companyArticlesToUse &&
                  associationChoice === companyAssociationChoice;

                if (
                  shouldDeleteTepmlateVersion &&
                  articlesOfAssociationToUse !== "ModelArticlesOfAssociation"
                ) {
                  //Remove previous template file
                  const response = await dispatch(
                    deleteDraftTemplateVersionAsync({
                      templateVersionId: templateVersionIdToDelete,
                    })
                  ).unwrap();

                  dispatch(updateTemplateState({ selectedTemplate: {} }));

                  setFieldValue("summary", {});
                  setFieldValue("fileUploads", {});
                  if (modalRow?.name) {
                    setFieldValue(modalRow.name, modalRow.value);
                    dispatch(closeModal(MODAL_NAME));
                  }
                }

                if (
                  shouldDeleteTemplate &&
                  articlesOfAssociationToUse !== "ModelArticlesOfAssociation"
                ) {
                  //Remove previous template
                  const response = await dispatch(
                    deleteDraftTemplateAsync({
                      templateId: templateIdToDelete,
                    })
                  ).unwrap();

                  if (response.error) {
                    toast(
                      "error",
                      response.payload?.message ??
                        "Something went wrong please try again"
                    );
                    return;
                  }

                  if (response?.data?.status === true) {
                    toast(
                      "success",
                      response.payload?.message ??
                        "Successfully deleted the template"
                    );
                    dispatch(updateTemplateState({ selectedTemplate: {} }));

                    setFieldValue("summary", {});
                    setFieldValue("fileUploads", {});
                    if (modalRow?.name) {
                      setFieldValue(modalRow.name, modalRow.value);
                      dispatch(closeModal(MODAL_NAME));
                    }
                  }
                }
              } else if (
                articlesOfAssociationToUse !== "ModelArticlesOfAssociation"
              ) {
                const fileName = values?.fileUploads?.template;

                // should delete the uploaded template file only
                if (fileName === fileNameToDelete) {
                  const response = await deleteFile({
                    fileName,
                    folder: "templates",
                  });
                  setFileNameToDelete("");
                  if (!_.isEmpty(selectedTemplate)) {
                    dispatch(updateTemplateState({ selectedTemplate: {} }));
                  }
                  setFieldValue("summary", {});
                  setFieldValue("fileUploads", {});
                }
              }
            }
            setFieldValue("summary", {});
            setFieldValue("fileUploads", {});
            if (!_.isEmpty(selectedTemplate)) {
              dispatch(updateTemplateState({ selectedTemplate: {} }));
            }
            if (modalRow?.name) {
              setFieldValue(modalRow.name, modalRow.value);
              dispatch(closeModal(MODAL_NAME));
            }
          } catch (error) {
            toast("error", "Something went wrong please try again");
          } finally {
            setDeletingPreviousTemplate(false);
          }
        };

        const handleChangeDate = (date) => {
          if (!date) {
            setFieldValue("dateOfChange", "");
            return;
          }
          if (isNaN(date.getTime())) {
            console.error("Invalid date:", date);
            return;
          }

          // Format the valid date
          const formattedDate = format(date, "yyyy/MM/dd");
          setFieldValue("dateOfChange", formattedDate);
        };

        const handleAdoptLatestArticles = () => {
          //handleAdoptLatestArticles
        };

        return (
          <Form>
            <fieldset
              disabled={role === Constants.COOKIE_ROLES.OFFICIAL || showOverlay}
              className="relative mt-2"
            >
              {showOverlay && <Overlay />}
              <SectionDescription
                //id="Step: 2 of 3"
                title="Articles Of Association"
                description="Please complete the relevant information in each of the following categories."
              />

              <div>
                <div className="mb-4 shadow-sm sm:rounded-md sm:overflow-hidden">
                  <div className="px-4 py-6 space-y-4 bg-white sm:p-6">
                    <div className="inline-block">
                      <p className="relative">
                        <span className="font-medium">
                          ARTICLES OF ASSOCIATION (Select the option that
                          applies)
                        </span>
                        {articlesOfAssociationToUseComments.length > 0 && (
                          <span className="absolute flex items-center justify-center p-1 h-4 text-white bg-red-700 rounded-full -top-2 -right-5">
                            <span>
                              {articlesOfAssociationToUseComments.length}
                            </span>
                          </span>
                        )}
                      </p>
                    </div>
                    <div className="flex items-center">
                      <Field
                        name="articlesOfAssociationToUse"
                        type="radio"
                        id="ModelArticlesOfAssociation"
                        value="ModelArticlesOfAssociation"
                        onChange={handleChangeArticlesOfAssociationToUse}
                        className="w-4 h-4 text-sflPrimary border-gray-300 focus:ring-green-focused disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none disabled:cursor-not-allowed"
                        disabled={values.resolvedFields.includes(
                          "articlesOfAssociationToUse"
                        )}
                      />
                      <label
                        htmlFor="ModelArticlesOfAssociation"
                        className="block ml-3 text-sm font-medium text-gray-700"
                      >
                        The company will adopt the model articles of association
                        applicable to a{" "}
                        {company?.type === "PVT"
                          ? "private company"
                          : "public company"}
                      </label>
                    </div>
                    <div className="flex items-center">
                      <Field
                        name="articlesOfAssociationToUse"
                        type="radio"
                        id="ModifiedArticlesOfAssociation"
                        value="ModifiedArticlesOfAssociation"
                        onChange={handleChangeArticlesOfAssociationToUse}
                        className="w-4 h-4 text-sflPrimary border-gray-300 focus:ring-green-focused disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none disabled:cursor-not-allowed"
                        disabled={values.resolvedFields.includes(
                          "articlesOfAssociationToUse"
                        )}
                      />
                      <label
                        htmlFor="ModifiedArticlesOfAssociation"
                        className="block ml-3 text-sm font-medium text-gray-700"
                      >
                        The company will adopt some of those model articles and
                        has prepared its own articles of association to
                        supplement or modify those model articles
                      </label>
                    </div>
                    <div className="flex items-center">
                      <Field
                        name="articlesOfAssociationToUse"
                        type="radio"
                        id="OwnArticlesOfAssociation"
                        value="OwnArticlesOfAssociation"
                        onChange={handleChangeArticlesOfAssociationToUse}
                        className="w-4 h-4 text-sflPrimary border-gray-300 focus:ring-green-focused disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none disabled:cursor-not-allowed"
                        disabled={values.resolvedFields.includes(
                          "articlesOfAssociationToUse"
                        )}
                      />
                      <label
                        htmlFor="OwnArticlesOfAssociation"
                        className="block ml-3 text-sm font-medium text-gray-700"
                      >
                        The company has prepared its own articles of association
                      </label>
                    </div>

                    {values.articlesOfAssociationToUse && (
                      <div className="m-4 p-4 bg-gray-100 space-y-2 sm:rounded-md sm:overflow-hidden">
                        <div className="flex items-center">
                          <Field
                            name="associationChoice"
                            type="radio"
                            id="uploadYourOwnOption"
                            value="uploadYourOwn"
                            onChange={handleChangeAssociationChoice}
                            className="w-4 h-4 text-sflPrimary border-gray-300 focus:ring-green-focused disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none disabled:cursor-not-allowed"
                            disabled={values.resolvedFields.includes(
                              "associationChoice"
                            )}
                          />
                          <label
                            htmlFor="uploadYourOwnOption"
                            className="block ml-3 text-sm font-medium text-gray-700"
                          >
                            Uploading your own articles of association
                          </label>
                        </div>
                        {getTemplateForApplicant.status === "loading" && (
                          <div className="flex justify-center mx-auto mt-10 text-white">
                            <SpinnerIcon className="text-gray-400" />
                          </div>
                        )}

                        {values.associationChoice === "uploadYourOwn" && (
                          <div>
                            <Field
                              name="fileUploads"
                              component={FileUploadForm}
                              documentData={[
                                {
                                  label: "",
                                  name: "template",
                                  accept: ".pdf, ",
                                },
                              ]}
                              innerRef={closeFilePreviewRef}
                              editorParams={{
                                containerHeight: "900px",
                              }}
                              folder="templates"
                            />
                            {["object", "undefined"].includes(
                              typeof values?.fileUploads?.template
                            ) && (
                              <div className="flex justify-end">
                                <Button
                                  onClick={handleUploadTemplate}
                                  disabled={!values.fileUploads?.template}
                                  isLoading={uploadingTemplate}
                                  loadingText="Uploading..."
                                >
                                  Upload
                                </Button>
                              </div>
                            )}
                            {typeof values.fileUploads.template ===
                              "string" && (
                              <TemplateSummary
                                ref={summaryFormRef}
                                selectedVersion={{
                                  summary: values.summary,
                                  fileUploads: values.fileUploads,
                                }}
                                comments={
                                  transformedComments.articlesOfAssociation
                                }
                              ></TemplateSummary>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    {articlesOfAssociationToUseComments.length > 0 && (
                      <CommentsList
                        comments={articlesOfAssociationToUseComments}
                        color={"text-red-500"}
                      />
                    )}
                    <ValidationError
                      errors={errors}
                      touched={touched}
                      name="articlesOfAssociationToUse"
                    />
                  </div>
                </div>
                <Field
                  name="articlesOfAssociation"
                  component={ArticlesOfAssociation}
                  transformedComments={transformedComments}
                />
                {!isConversionTransaction && (
                  <div className="shadow-sm sm:rounded-md sm:overflow-hidden px-4 py-6 space-y-4 bg-white sm:p-6 mt-4">
                    <DatePickerField
                      label="Effective date of change of Articles"
                      onChange={handleChangeDate}
                      selected={
                        values.dateOfChange
                          ? new Date(values.dateOfChange)
                          : null
                      }
                      name="dateOfChange"
                      minDate={dateFrom}
                      maxDate={dateTo}
                      placeholderText="Enter date of change"
                      errorPath="dateOfChange"
                      disabled={false}
                      showRequiredAsterisk
                    />
                    <ValidationError
                      errors={errors}
                      touched={touched}
                      name="dateOfChange"
                    />
                  </div>
                )}
              </div>
            </fieldset>
            <div className="flex justify-between items-center mt-6">
              <button
                type="button"
                onClick={() => handleSummaryNavigation("prev")}
                className="flex items-start float-right p-2 font-semibold rounded text-primary hover:bg-gray-700 hover:text-white"
              >
                <span className="flex items-center mr-4 h-7">
                  <ChevronLeftIcon
                    className="flex-shrink-0 w-5 h-5"
                    aria-hidden="true"
                  />
                </span>
                <p className="font-semibold">Go back</p>
              </button>
              <Button
                onClick={handleSubmit}
                isLoading={isSubmitting}
                postIcon={ChevronRightIcon}
                className="flex button button-hover button-disabled button-outline button-focus bg-sflPrimary px-2 py-2 text-white"
              >
                Save and proceed
              </Button>
            </div>
            <ModalWrapper
              name={MODAL_NAME}
              title="Warning"
              titleColor="text-red-500"
              maxWidth="sm:max-w-[35%]"
            >
              <div className="my-4 text-lg">
                You will lose all data relating to the articles of association
                you have provided so far.
              </div>
              <hr />
              <div className="flex justify-end mt-4 space-x-4">
                <Button
                  onClick={() => dispatch(closeModal(MODAL_NAME))}
                  variant="outline"
                  disabled={deletingPreviousTemplate}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  onClick={handleRemovePreviousTemplateVersion}
                  loadingText="Removing..."
                  isLoading={deletingPreviousTemplate}
                >
                  Proceed
                </Button>
              </div>
            </ModalWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Governance;
function fiteredVersions(templateVersions) {
  return templateVersions
    .filter((version) => version.status !== "Draft")
    .sort((a, b) => {
      // Convert version numbers to numbers for proper sorting
      const versionA = parseFloat(a.versionNumber);
      const versionB = parseFloat(b.versionNumber);
      return versionB - versionA;
    });
}
